import React, { useState } from 'react';
import PaymentList from '../components/PaymentList';

const PaymentPage = () => {
    const [activeTab, setActiveTab] = useState('gst');

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">Payments</h1>
                    <p className="text-gray-600">Manage invoice payments and track outstanding balances</p>
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    <button
                        onClick={() => setActiveTab('gst')}
                        className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'gst'
                                ? 'border-primary-500 text-primary-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
                    >
                        Add Payment (GST)
                    </button>
                    <button
                        onClick={() => setActiveTab('non-gst')}
                        className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'non-gst'
                                ? 'border-primary-500 text-primary-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
                    >
                        Add Payment (Non-GST)
                    </button>
                </nav>
            </div>

            {/* Content */}
            <div className="mt-6">
                <div className={activeTab === 'gst' ? 'block' : 'hidden'}>
                    <PaymentList type="gst" />
                </div>
                <div className={activeTab === 'non-gst' ? 'block' : 'hidden'}>
                    <PaymentList type="non-gst" />
                </div>
            </div>
        </div>
    );
};

export default PaymentPage;
